import { PayloadAction } from '@reduxjs/toolkit';
import { QUOTE_LINE_INFO_TABS } from '@ui/config/price/constants';
import { WritableDraft } from 'immer';

import { QuoteBuilderStateType } from '../../types/state';
import { QuoteLineInternalType } from '../../types/state/quote-line';
import { getQuoteLineOrThrow } from '../utilities/action-guards';
import { QuoteLineParams } from './types';

type ValidTabs =
  | typeof QUOTE_LINE_INFO_TABS.QUOTE_HISTORY
  | typeof QUOTE_LINE_INFO_TABS.ORDER_HISTORY;

type Params = QuoteLineParams & {
  tab: ValidTabs;
  exactMatch?: boolean;
};

const tabToStateVariableMap: Record<
  ValidTabs,
  keyof Pick<
    QuoteLineInternalType,
    'infoTabQuoteHistoryExactMatch' | 'infoTabOrderHistoryExactMatch'
  >
> = {
  [QUOTE_LINE_INFO_TABS.QUOTE_HISTORY]: 'infoTabQuoteHistoryExactMatch',
  [QUOTE_LINE_INFO_TABS.ORDER_HISTORY]: 'infoTabOrderHistoryExactMatch',
};

export function quoteLineInfoExactMatchToggled(
  state: WritableDraft<QuoteBuilderStateType>,
  action: PayloadAction<Params>,
) {
  const { exactMatch } = action.payload;

  const quoteLine = getQuoteLineOrThrow(state, action.payload.quoteLineUuid);

  if (exactMatch === undefined) {
    quoteLine[tabToStateVariableMap[action.payload.tab]] =
      !quoteLine[tabToStateVariableMap[action.payload.tab]];
  } else {
    quoteLine[tabToStateVariableMap[action.payload.tab]] = exactMatch;
  }
}
